import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDashboard,
  selectDataDashboard,
  selectDataSynch,
  selectLoading,
} from "./company/companySlice";
import {
  defaultDate,
  filterDataDesc,
  formatCurrency,
  formatQuantity,
  getRandomBorderColor,
  getRandomColor,
} from "../utility";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Col, Row } from "react-bootstrap";
import { LayoutSplashScreen } from "../../_metronic/layout";
import { NavLink } from "react-router-dom";

import {
  Doughnut,
  Bar,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
  Pie,
} from "react-chartjs-2";

import {
  Chart as ChartJS,
  ArcElement,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import { Card, CardBody } from "../../_metronic/_partials/controls";

export const DashboardDetailPage = () => {
  const dispatch = useDispatch();

  const data = useSelector(selectDataDashboard);
  const loading = useSelector(selectLoading);
  const [tableDataCustomer, setTableDataCustomer] = useState([]);
  const [tableDataProduct, setTableDataProduct] = useState([]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchDashboard({ start_date: defaultDate, end_date: defaultDate })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (data !== null) {
      const initData = data.customers.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setTableDataCustomer(initData);
      const initData2 = data.products.map((item, index) => {
        return {
          ...item,
          no: index + 1,
        };
      });
      setTableDataProduct(initData2);
    }
  }, [data]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Row>
          <Col md={7}>
            <Row>
              <Col className="mt-3">
                <div className={`card card-custom`}>
                  <div className="card-body p-0">
                    <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                      <span
                        className={`symbol symbol-50 symbol-light-secondary mr-2`}
                      >
                        <span className="symbol-label">
                          <span
                            className={`svg-icon svg-icon-xl svg-icon-danger`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Map/Marker1.svg"
                              )}
                            ></SVG>
                          </span>
                        </span>
                      </span>
                      <div className="d-flex flex-column text-right">
                        <span className="text-dark-75 font-weight-bolder font-size-h3">
                          {data?.target_call}
                        </span>
                        <span className="text-muted font-weight-bold mt-2">
                          Target Call
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="mt-3">
                <div className={`card card-custom`}>
                  <div className="card-body p-0">
                    <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                      <span
                        className={`symbol symbol-50 symbol-light-secondary mr-2`}
                      >
                        <span className="symbol-label">
                          <span
                            className={`svg-icon svg-icon-xl svg-icon-warning`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Map/Location-arrow.svg"
                              )}
                            ></SVG>
                          </span>
                        </span>
                      </span>
                      <div className="d-flex flex-column text-right">
                        <span className="text-dark-75 font-weight-bolder font-size-h3">
                          {data?.actual_call}
                        </span>
                        <span className="text-muted font-weight-bold mt-2">
                          Actual Call
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col className="mt-3">
                <div className={`card card-custom`}>
                  <div className="card-body p-0">
                    <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                      <span
                        className={`symbol symbol-50 symbol-light-secondary mr-2`}
                      >
                        <span className="symbol-label">
                          <span
                            className={`svg-icon svg-icon-xl svg-icon-danger`}
                          >
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Map/Direction2.svg"
                              )}
                            ></SVG>
                          </span>
                        </span>
                      </span>
                      <div className="d-flex flex-column text-right">
                        <span className="text-dark-75 font-weight-bolder font-size-h3">
                          {data?.effective_call}
                        </span>
                        <span className="text-muted font-weight-bold mt-2">
                          Effective Call
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

          <Col md={5} className="mt-3">
            <div className={`card card-custom`}>
              <div className="card-body p-0">
                <div className="d-flex align-items-center justify-content-between card-spacer flex-grow-1">
                  <span
                    className={`symbol symbol-50 symbol-light-secondary mr-2`}
                  >
                    <span className="symbol-label">
                      <span className={`svg-icon svg-icon-xl svg-icon-success`}>
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/Shopping/Chart-bar1.svg"
                          )}
                        ></SVG>
                      </span>
                    </span>
                  </span>
                  <div className="d-flex flex-column text-right">
                    <span className="text-dark-75 font-weight-bolder font-size-h3">
                      {formatCurrency(data?.revenue)}
                    </span>
                    <span className="text-muted font-weight-bold mt-2">
                      Revenue
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className="mt-5">
        <Row>
          <Col sm={6}>
            <div className={`card card-custom `}>
              {/* Head */}
              <div className="card-header border-0">
                <h3 className="card-title font-weight-bolder text-dark">
                  Top Customers
                </h3>
              </div>
              {/* Body */}
              <div className="card-body pt-2">
                {tableDataCustomer && tableDataCustomer.length > 0 ? (
                  tableDataCustomer.map((item, index) => {
                    return (
                      <div
                        className="d-flex align-items-center mb-3"
                        key={index}
                      >
                        <span className="bullet bullet-bar bg-success align-self-stretch"></span>

                        <div className="d-flex flex-column flex-grow-1 ml-3">
                          <span className="text-dark-75  font-weight-bold font-size-lg mb-1">
                            <NavLink
                              className="menu-link"
                              to={`/master/customer/edit/${item.customer_id}?additionalParam=Order History`}
                            >
                              <b>{item.customer_store_name}</b>
                            </NavLink>
                          </span>
                        </div>
                        <div className="d-flex flex-column flex-grow-1">
                          <span className="text-dark-75 text-hover-primary text-right font-weight-bold font-size-lg mb-1">
                            {formatCurrency(item.revenue)}
                          </span>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center p-5">
                    <span className="text-muted">No data available</span>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col sm={6}>
            <div className={`card card-custom `}>
              {/* Head */}
              <div className="card-header border-0">
                <h3 className="card-title font-weight-bolder text-dark">
                  Top Products
                </h3>
              </div>
              {/* Body */}
              <div className="card-body pt-2">
                {tableDataProduct && tableDataProduct.length > 0 ? (
                  tableDataProduct.map((item, index) => {
                    return (
                      <div
                        className="d-flex align-items-center mb-3"
                        key={index}
                      >
                        <span className="bullet bullet-bar bg-success align-self-stretch"></span>

                        <div className="d-flex flex-column flex-grow-1 ml-3">
                          <span className="text-dark-75  font-weight-bold font-size-lg mb-1">
                            <NavLink
                              className="menu-link"
                              to={`/master/product/edit/${item.product_id}`}
                            >
                              <b>
                                {item.product_code} - {item.product_name}
                              </b>
                            </NavLink>
                          </span>
                        </div>
                        <div className="d-flex flex-column flex-grow-1">
                          <span className="text-dark-75 text-hover-primary text-right font-weight-bold font-size-lg mb-1">
                            {formatQuantity(item.quantity)}
                          </span>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="text-center p-5">
                    <span className="text-muted">No data available</span>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
